import { userPreferencesFeatureKey } from 'features/user-preferences/user-preferences.constants';
import {
  customFieldsPreferencesReducer,
  dashboardPreferencesReducer,
  reportsPreferencesReducer,
  tablePreferencesReducer,
} from 'features/user-preferences/store/user-preferences.reducer';
import { UserPreferencesEffects } from './user-preferences.effects';
import { importProvidersFrom } from '@angular/core';
import { ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { localStorageSync } from 'ngrx-store-localstorage';

const userPreferencesReducers = {
  tables: tablePreferencesReducer,
  customFields: customFieldsPreferencesReducer,
  dashboard: dashboardPreferencesReducer,
  reports: reportsPreferencesReducer,
};

function jsonReplacer(_key: unknown, value: unknown) {
  if (typeof value === 'undefined') {
    return null;
  }

  return value;
}

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: [{ tables: { replacer: jsonReplacer } }, 'customFields', 'dashboard', 'reports'],
    rehydrate: true,
  })(reducer);
}

export const provideUserPreferences = () => {
  return importProvidersFrom(
    EffectsModule.forFeature([UserPreferencesEffects]),
    StoreModule.forFeature(userPreferencesFeatureKey, userPreferencesReducers, {
      metaReducers: [localStorageSyncReducer],
    }),
  );
};
